export default '/build/ba06d998.svg'